import { DisplayTransactionType } from '@features/bankTransactions/enums/displayTransactionType'

import { Side } from '../../../../../../../enums/side'

export const getTransferType = (side: Side): DisplayTransactionType =>
  side === Side.Credit ? DisplayTransactionType.TransferOut : DisplayTransactionType.TransferIn
